export enum COUNTRY {
  PERU = 1,
  ECUADOR = 6
}

const DNI = {
  label: 'DNI',
  value: 'DNI'
};

const RUC = {
  label: 'RUC',
  value: 'RUC'
};

const CE = {
  label: 'Carnet de Extranjeria',
  value: 'CE'
};

const PAS = {
  label: 'Pasaporte',
  value: 'PAS'
};

const CD = {
  label: 'Cédula',
  value: 'CD'
};

export const SELECT_DOCUMENT = {
  [COUNTRY.PERU]: [
    DNI,
    RUC,
    CE,
    PAS
  ],
  [COUNTRY.ECUADOR]: [
    CD,
    CE,
    RUC,
    PAS
  ]
};

const PEN = {
  label: 'Soles ( S/ )',
  value: 'PEN'
};

const USD = {
  label: 'Dólares ( $ )',
  value: 'USD'
};

export const SELECT_CURRENCY = {
  [COUNTRY.PERU]: [
    PEN,
    USD
  ],
  [COUNTRY.ECUADOR]: [
    USD
  ]
};
